const Footer = () => {
	return (
		<footer className='footer'>
			<p className='footer_text'>Es tiempo de creer en tu futuro. &reg;</p>
		</footer>
	)
}

export default Footer
